module.exports = __webpack_public_path__ + "static/media/nn_skrivhastighet_video.eae10806.mov";